import axios from '@axios'

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async index() {
      const { data } = await axios.get('/user/assets')
      return data
    },
    async create(a, payload) {
      const { data } = await axios.post('/user/assets', payload)
      return data
    },
    delete(a, id) {
      return axios.delete(`/user/assets/${id}`)
    },
  },
}
